/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Notetaker_Issue_AfterInputs */



/**
* | output |
* | --- |
* | "So no report will come on its own — share your notes and Wundo will write one." |
*
* @param {Meeting_Notetaker_Issue_AfterInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_notetaker_issue_after = /** @type {((inputs?: Meeting_Notetaker_Issue_AfterInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Notetaker_Issue_AfterInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Er komt dus geen verslag vanzelf — deel je notities, dan maakt Wundo er een.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucun compte rendu ne viendra donc tout seul — partagez vos notes, et Wundo en rédige un.")
	return /** @type {LocalizedString} */ ("So no report will come on its own — share your notes and Wundo will write one.")
});